{
  "name": "@basictech/react",
  "version": "0.7.0-beta.6",
  "description": "",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "private": false,
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "test": "echo \"Error: no test specified\" && exit 1"
  },
  "author": "",
  "license": "ISC",
  "dependencies": {
    "ajv": "^8.17.1",
    "dexie": "^4.2.1",
    "dexie-observable": "^4.0.1-beta.13",
    "dexie-react-hooks": "^4.2.0",
    "dexie-syncable": "^4.0.1-beta.13",
    "jwt-decode": "^4.0.0",
    "uuid": "^10.0.0",
    "@basictech/schema": "0.6.0"
  },
  "devDependencies": {
    "@repo/typescript-config": "*",
    "tsup": "^7.2.0",
    "typescript": "^5.0.0"
  },
  "peerDependencies": {
    "react": "^16.8.0 || ^17.0.0 || ^18.0.0 || ^19.0.0"
  }
}
